import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { Button } from '../ui/Button';

export const Header: React.FC = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-16">
          <div className="flex-1 flex items-center">
            {/* Placeholder for future logo/branding */}
          </div>

          <div className="flex-1 flex justify-center">
            {user && (
              <nav className="flex items-center bg-gray-100 rounded-full p-1">
                {[
                  { label: 'Performance', to: '/performance', isActive: (path: string) => path === '/performance' || path === '/' },
                  { label: 'Users', to: '/config', isActive: (path: string) => path.startsWith('/config') },
                  { label: 'Config', to: '/global-config', isActive: (path: string) => path.startsWith('/global-config') },
                  { label: 'Logs', to: '/logs', isActive: (path: string) => path.startsWith('/logs') },
                ].map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className={`text-sm font-medium px-4 py-2 rounded-full transition-colors ${
                      link.isActive(location.pathname)
                        ? 'bg-white text-blue-600 shadow'
                        : 'text-gray-600 hover:text-gray-900'
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
              </nav>
            )}
          </div>

          <div className="flex-1 flex items-center justify-end">
            {user ? (
              <Button
                onClick={handleSignOut}
                size="icon"
                variant="secondary"
                className="bg-gray-100 text-gray-700 hover:bg-gray-200"
                title={`Logged in as ${user.email}`}
                aria-label="Sign out"
              >
                <LogOut className="h-4 w-4" />
              </Button>
            ) : (
              <Button onClick={() => navigate('/login')} size="sm">
                Sign In
              </Button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
